import { render, staticRenderFns } from "./OverviewTab.vue?vue&type=template&id=f3c4ec96&scoped=true"
import script from "./OverviewTab.vue?vue&type=script&lang=js"
export * from "./OverviewTab.vue?vue&type=script&lang=js"
import style0 from "./OverviewTab.vue?vue&type=style&index=0&id=f3c4ec96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c4ec96",
  null
  
)

export default component.exports